<template>
  <el-dialog class="cert-map-dialog common-dialog" :close-on-click-modal="false" :visible.sync="dialogVisible"
    :before-close="handleCancel" :title="title">
    <div class="map-box">
      <normal-table ref="commonTable" :table-col="tableCol" :table-data="list" :paging="paging"
        @pagination="handleSizeOrPageChange">
        <template slot="mapping" slot-scope="{ param }">
          <el-button v-if="param.row.IsMap === 1" class="goBtn" type="primary" disabled>已映射</el-button>
          <el-button v-else class="goBtn" type="primary" @click="mapping(param.row)">映射</el-button>
        </template>
      </normal-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CertMap',
  data() {
    return {
      dialogVisible: false,
      title: '证书映射',
      // 设置table的列
      tableCol: [
        {
          prop: 'id',
          label: '证书ID',
          minWidth: 100
        },
        {
          prop: 'CertUse',
          label: '证书用途',
          formatter: row => {
            return this.formatUsage(row.CertUse)
          },
          minWidth: 120
        },
        {
          prop: 'UserName',
          label: '用户名称',
          minWidth: 180
        },
        {
          prop: 'CertType',
          label: '节点角色',
          formatter: row => {
            return this.formatRole(row.CertType)
          },
          minWidth: 120
        },
        {
          prop: 'Algorithm',
          label: '密码算法',
          formatter: row => {
            return this.formatAlgo(row.Algorithm)
          },
          minWidth: 80
        },
        {
          prop: 'OrgName',
          label: '所属组织',
          minWidth: 120
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.createAt)
          },
          minWidth: 160
        },
        {
          prop: 'Status',
          label: '证书状态',
          formatter: row => {
            return this.formatStatus(row.Status)
          },
          minWidth: 80
        },
        {
          prop: 'work',
          label: '操作',
          slotName: 'mapping',
          minWidth: 100
        }
      ],
      paging: {
        total: 0,
        offset: 0,
        limit: 10
      },
      list: [],
      userId: ''
    }
  },
  methods: {
    getList() {
      let param = {
        offset: this.paging.offset,
        limit: this.paging.limit,
        userId: this.userId
      }
      this.$apis.system.getCert(param).then(res => {
        if (res.data) {
          this.list = res.data.items
          this.paging.offset = res.data.offset
          this.paging.limit = res.data.limit
          this.paging.total = res.data.total
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(row) {
      this.userId = row.id
      this.getList()
      this.dialogVisible = true
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    formatAlgo(algo) {
      return algo === 0 ? '国密' : 'ECDSA'
    },
    formatUsage(usage) {
      switch (usage) {
        case 0:
          return '签名'
        case 1:
          return '通信'
        case 2:
          return 'PEM'
        case 3:
          return 'IBC签名'
        case 4:
          return 'IBC通信'
        default:
          return '未知用途:' + usage
      }
    },
    formatRole(role) {
      let type = ['组织证书', '管理员用户', '普通用户', '共识节点', '普通节点', '轻节点', '根证书']
      return type[role - 1]
    },
    formatStatus(status) {
      return status === 'normal' ? '正常' : '已撤销'
    },
    judgeShow(row, type) {
      let con1 = row.IsMap === 0 && type === 'map'
      let con2 = row.IsMap === 1 && type === 'ismap'
      return con1 || con2
    },
    mapping(row) {
      let param = {
        certId: row.id,
        userId: this.userId
      }
      this.$apis.system.mapCert(param).then(res => {
        if (res) {
          this.$message.success(`证书映射成功`)
          this.getList()
        }
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.paging.offset = offset * limit
      this.paging.limit = limit
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cert-map-dialog.common-dialog {
  @include adaptation(
    (
      --cert-map-dialog-map-box-min-height: 680px,
      --cert-map-dialog-map-box-list-min-height: 680px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-huge-width);

    .el-dialog__body {
      padding-bottom: var(--base-size-24);
    }
  }

  .map-box {
    min-height: var(--cert-map-dialog-map-box-min-height);

    .normal-table-wrap {
      height: 100%;
      min-height: var(--cert-map-dialog-map-box-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--cert-map-dialog-map-box-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--cert-map-dialog-map-box-list-min-height);
        }
      }
    }
  }
}
</style>
